import React, { useContext } from 'react';
import {IconButton} from '@mui/material'
import {DataContext} from '../../dataContext'
import {Launch} from '@mui/icons-material'
import getColorOverride from '../../utilities/functions';
import { useParams } from 'react-router';

function ResultsBox({results, filter, handleSelectRiding}) {
    const {data} = useContext(DataContext)
    const {prov, year} = useParams()

    const getColor = (candidate) => {
        try {
            const partyCode = candidate.partyCode
            let partyInfo = data.current.party.partyResults.find(party => {
                return party.nameShort === partyCode
            })
    		const getColor = getColorOverride(partyCode, `${prov}_${year}`)

            if (partyInfo) {
                if (getColor) {
                    return getColor
                }
                return partyInfo
            }  
            return {
                color: "rgb(114, 118, 133)",
                name: "Other",
                nameShort: "OTH"
            }
        } catch (e) {
            return {
                color: "rgb(114, 118, 133)",
                name: "Other",
                nameShort: "OTH"
            }
        }
    }

    const getRidingResults = (ridingName) => {
        let riding =  data.current.full.data.find(el=>el.name === ridingName)
        handleSelectRiding(riding);
    }

    return (
        <div className={'classes.resultsRoot h-full overflow-scroll'}>
            {/* <div className={'classes.title'}>{filter}</div> */}
            <div className={'classes.candidateContainer px-1 flex flex-col gap-2'}>
            {(filter && results.data.length > 0) ? results.data.map((candidate,i)=>{
                const partyData = getColor(candidate)
                return (
                <div key={i} id="filteredCandidate" className={'classes.candidateRoot grid grid-cols-2 gap-2'} onClick={()=>getRidingResults(candidate.riding)}>
                    <div className={'classes.candidateLeftDiv flex flex-col gap-1'}>
                        <div id="candidateRiding" className='text-base sm:text-xl font-bold font-light'>                            
                            <span>{candidate.riding}</span>
                            <IconButton  aria-label={`More information on ${candidate.riding} riding opens in a modal`} onClick={()=>getRidingResults(candidate.riding)}>
                                <Launch/>
                            </IconButton>
                        </div>
                        <div className={'classes.candidateName'}>
                            <div id="candidateName" className='text-base sm:text-lg'>{candidate.firstName + ' ' + candidate.lastName}</div>
                            <div id="candidateParty" className={'font-semibold text-lg'}style={{ color: partyData.color}}>{candidate.partyCode}</div>
                         </div>
                        
                    </div>
                    <div className={'classes.candidateRightDiv text-right flex flex-col gap-2'}>
                        <div id='pollsDiv' className='text-sm'>
                                <div>{candidate.pollsReported}/{candidate.pollsTotal} polls reporting</div>
                        </div>
                        <div className={'classes.votesDiv'}>
                            <div>
                                <div id='votesLabel' className="text-lg font-bold font-light ">Leading By: </div>
                                <div>{candidate.lead.toLocaleString('en')} votes</div>
                                <div>{candidate.leadPercent}%</div>
                            </div>
                            
                        </div>
                    </div>
                    
                </div>)
            }):
            <div>Filtered results data will be made available as results come in.</div>
            }
            </div>
        </div>
    )
}

export default ResultsBox
